"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaperlessSettings = exports.unlinkPolicy = exports.setResponse = exports.setPolicyType = exports.setPolicyNumber = exports.resetAccount = exports.registerStart = exports.register = exports.loadAccount = exports.getPaperlessSettings = exports.getNotifications = exports.getBillPreference = exports.fetchPolicTypeForWithPolicyNumber = exports.clearPolicyTypeInfo = exports.clearAccount = void 0;
var _environment = _interopRequireDefault(require("../../environment"));
var t = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* ACTION CREATOR FUNCTIONS
Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects
*/

var registerUrl = _environment.default.REGISTRATION.registerUrl;
var billingPrefUrl = _environment.default.ACCOUNT.billingAccountUrl;
var paperlessSettingsUrl = _environment.default.ACCOUNT.paperlessSettingsUrl;
var paperlessUpdateUrl = _environment.default.ACCOUNT.paperlessUpdateUrl;
var unlinkPolicyUrl = _environment.default.POLICY.unlinkPolicyUrl;
var notificationsUrl = _environment.default.ACCOUNT.notificationsUrl;
var getPolicyTypeUrl = _environment.default.REGISTRATION.getPolicyTypeUrl;
var loadAccount = exports.loadAccount = function loadAccount(account) {
  return {
    type: t.LOAD,
    payload: account
  };
};
var register = exports.register = function register(account) {
  return {
    type: t.REGISTER,
    payload: account
  };
};
var setResponse = exports.setResponse = function setResponse(response) {
  return {
    type: t.VERIFY,
    payload: response
  };
};
var clearAccount = exports.clearAccount = function clearAccount() {
  return {
    type: t.CLEAR,
    payload: {}
  };
};
var resetAccount = exports.resetAccount = function resetAccount() {
  return {
    type: t.RESET,
    payload: {}
  };
};
var setPolicyType = exports.setPolicyType = function setPolicyType(response) {
  return {
    type: t.GET_POLICY_TYPE_SUCCESS,
    payload: response
  };
};
var clearPolicyTypeInfo = exports.clearPolicyTypeInfo = function clearPolicyTypeInfo() {
  return {
    type: t.CLEAR_POLICY_INFO,
    payload: {}
  };
};
var setPolicyNumber = exports.setPolicyNumber = function setPolicyNumber(policyNumber) {
  return {
    type: t.SET_POLICY_NUMBER,
    payload: policyNumber
  };
};
var registerStart = exports.registerStart = function registerStart(account) {
  return {
    type: t.REGISTER_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: registerUrl,
      body: account
    }
  };
};
var fetchPolicTypeForWithPolicyNumber = exports.fetchPolicTypeForWithPolicyNumber = function fetchPolicTypeForWithPolicyNumber(policyNumber) {
  return {
    type: t.GET_POLICY_TYPE_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: _url(getPolicyTypeUrl, policyNumber)
    }
  };
};
var getBillPreference = exports.getBillPreference = function getBillPreference() {
  return {
    type: t.BILL_PREF_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: billingPrefUrl
    }
  };
};
var getPaperlessSettings = exports.getPaperlessSettings = function getPaperlessSettings(policies) {
  return {
    type: t.GET_PAPERLESS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: paperlessSettingsUrl,
      body: policies
    }
  };
};
var updatePaperlessSettings = exports.updatePaperlessSettings = function updatePaperlessSettings(paperlessSettings) {
  return {
    type: t.UPDATE_PAPERLESS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: paperlessUpdateUrl,
      body: paperlessSettings
    }
  };
};
var getNotifications = exports.getNotifications = function getNotifications() {
  return {
    type: t.NOTIFICATIONS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: notificationsUrl
    }
  };
};
var unlinkPolicy = exports.unlinkPolicy = function unlinkPolicy(policyNumber) {
  return {
    type: t.UNLINK_POLICY_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: unlinkPolicyUrl + policyNumber
    }
  };
};
var _url = function _url() {
  for (var _len = arguments.length, fragments = new Array(_len), _key = 0; _key < _len; _key++) {
    fragments[_key] = arguments[_key];
  }
  var url = fragments.join('/');
  return url;
};